import React, { forwardRef } from "react";
import { ODSText } from "@/atoms";
import ODSCheckmark from "@/atoms/ODSIcons/checkmark/ODSCheckmark";
import classNames from "classnames";

import { ODSDropdownSelectMenuItemProps } from "./ODSDropdownSelect.types";

const ODSDropdownSelectMenuItem = forwardRef<
  HTMLButtonElement,
  ODSDropdownSelectMenuItemProps
>(
  (
    {
      className,
      active,
      labelText,
      disabled = false,
      selected = false,
      size = "large",
      ...rest
    },
    ref
  ) => {
    return (
      <button
        ref={ref}
        className={classNames(
          `ODSDropdownSelectMenuItem`,
          selected && `ODSDropdownSelectMenuItem--selected`,
          active && `ODSDropdownSelectMenuItem--active`,
          `ODSDropdownSelectMenuItem--size-${size}`,
          className
        )}
        aria-disabled={disabled}
        aria-checked={selected}
        role="option"
        aria-label={labelText}
        {...rest}
      >
        <ODSText
          as="span"
          title={labelText}
          className="ODSDropdownSelectMenuItem-Label"
        >
          {labelText}
        </ODSText>

        {selected ? (
          <ODSCheckmark
            tabIndex={undefined}
            aria-hidden="true"
            className="ODSDropdownSelectMenuItem-Checkmark"
            selected
          />
        ) : null}
      </button>
    );
  }
);

ODSDropdownSelectMenuItem.displayName = "ODSDropdownSelectMenuItem";

export default ODSDropdownSelectMenuItem;
